"use client";

import {
  Button,
  cn,
  type KyanIcon,
  ModalContainer,
  ModalContent,
  Typography,
} from "@kyan/ui";
import { useState } from "react";

import { GradientIcon } from "#/components/GradientIcon/GradientIcon";
import { useRfqRequests } from "#/store/rfq/rfqRequests";

import styles from "./RfqModal.module.css";

const items: { title: string; icon: KyanIcon; description: string }[] = [
  {
    title: "Awaiting responses",
    icon: "clock",
    description:
      "Market Makers have up to 5 minutes to respond. Please allow some time for them to provide their quotes.",
  },
  {
    title: "Order canceled",
    icon: "error-circle",
    description:
      "The Market Maker may have canceled the order, which would prevent a response from being displayed.",
  },
];

export const RfqModal: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { requestsAwaitingResponses } = useRfqRequests();

  return (
    <>
      <div className="hidden items-center gap-3 whitespace-nowrap sm:flex">
        {requestsAwaitingResponses.length > 0 && (
          <div
            className={cn(
              "mx-auto mb-0 inline-block bg-linear-to-r from-gray-800 via-white to-gray-800 px-0 text-center text-xs text-transparent",
              styles.shimmer,
            )}
          >
            Awaiting Responses ({requestsAwaitingResponses.length})
          </div>
        )}
        <Button
          size="sm"
          variant="link"
          onClick={() => {
            setShowModal(true);
          }}
        >
          Don’t see any responses?
        </Button>
      </div>

      <ModalContainer open={showModal} onOpenChange={setShowModal}>
        <ModalContent
          exitDelay={0.1}
          className="flex w-full max-w-[433px] flex-col items-center"
        >
          <Typography
            bold
            grotesk
            primary
            element="h2"
            className="block w-full text-left"
          >
            Don’t see any responses?
          </Typography>
          <Typography className="mt-5 mb-6 block w-full text-left">
            There can be one of the two reasons for that
          </Typography>

          <div className="mb-6 flex flex-col gap-6">
            {items.map(({ title, icon, description }) => (
              <div
                key={title}
                className="flex flex-col items-start gap-4 rounded-sm bg-[#FAFAFA]/70 p-5 text-left dark:bg-[#101010]/70"
              >
                <div className="flex items-center gap-4">
                  <GradientIcon size="sm" name={icon} />
                  <Typography weight="bold" variant="primary">
                    {title}
                  </Typography>
                </div>
                <Typography>{description}</Typography>
              </div>
            ))}
          </div>

          <Button
            size="lg"
            className="mt-4 w-full shadow-none"
            onClick={() => {
              setShowModal(false);
            }}
          >
            Got it
          </Button>
        </ModalContent>
      </ModalContainer>
    </>
  );
};
